<template>
  <div class="c-side-nav">
    <ul class="c-side-nav-list">
      <li>
          <h3><img src="../../assets/main/account-management@2x.png">账号管理</h3>
          <div class="c-side-atems" :class="{'active': nav === 'profile'}">
            <router-link :to="{name: 'Profile'}">
              个人资料
            </router-link>
          </div>
          <div class="c-side-atems" :class="{'active': nav === 'org'}">
            <router-link :to="{name: 'Organization'}">
              机构管理
            </router-link>
          </div>
          <div class="c-side-atems" :class="{'active': nav === 'specialist' || nav === 'specialist-create'}">
            <router-link :to="{name: 'Specialist'}">
              专家注册
            </router-link>
          </div>
      </li>
      <li>
          <h3><img src="../../assets/main/mima@2x.png">安全设置</h3>
          <div class="c-side-atems" :class="{'active': nav === 'passw-change'}">
            <router-link :to="{name: 'PasswordChange'}">
              密码修改
            </router-link>
          </div>
      </li>
      <li>
          <h3><img src="../../assets/main/yewu.png">业务管理</h3>
          <div class="c-side-atems" :class="{'active': nav === 'publish-proj'}">
            <router-link :to="{name: 'PublishProject'}">
              已发布项目
            </router-link>
          </div>
          <div class="c-side-atems" :class="{'active': nav === 'source-match'}">
            <router-link :to="{name: 'SourceMatch'}">
              已报名项目
            </router-link>
          </div>
          <div class="c-side-atems" :class="{'active': nav === 'engage-specialist'}">
            <router-link :to="{name: 'EngageSpecialist'}">
              聘专家
            </router-link>
          </div>
          <div class="c-side-atems" :class="{'active': nav === 'policy-advisory'}">
            <router-link :to="{name: 'PolicyAdvisory'}">
              政策咨询
            </router-link>
          </div>
          <div class="c-side-atems" :class="{'active': nav === 'create-standard'}">
            <router-link :to="{name: 'CreateStandard'}">
              创标准
            </router-link>
          </div>
          <!-- <div class="c-side-atems" :class="{'active': nav === 'my-video'}">
            <router-link :to="{name: 'MyVideo'}">
              我的视频
            </router-link>
          </div> -->
          <div class="c-side-atems" :class="{'active': nav === 'mutual-evaluation'}">
            <router-link :to="{name: 'MutualEvaluation'}">
              评价
            </router-link>
          </div>
      </li>
      <li>
          <h3><img src="../../assets/main/xiaoxizhongxin@2x.png">消息中心</h3>
          <div class="c-side-atems" :class="{'active': nav === 'message-c'}">
            <router-link :to="{name: 'MessageCenter'}">
              全部消息
            </router-link>
          </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
    name: 'SideNav',
    props: {
        msg: String,
    },
    data() {
        return {
            nav: '',
            routes: {
                specialist: {

                }
            }
        }
    },
    watch: {
        $route(to, from) {
            this.matchNav(to);
        }
    },
    mounted() {
        this.matchNav(this.$route);
    },
    methods: {
        matchNav(route) {
            if (route.path.includes('profile')) {
                this.nav = 'profile';
            }
            if (route.path.includes('/org')
      || route.path.includes('/product-m')
      || route.path.includes('/scene-m')
      || route.path.includes('/service-m')
      || route.path.includes('/case-m')
            ) {
                this.nav = 'org';
            }
            if (route.path.includes('/message-c')
            ) {
                this.nav = 'message';
            }
            if (route.path.includes('/passw-change')
            ) {
                this.nav = 'passw';
            }
            const path = route.path;
            this.nav = path.substr(path.lastIndexOf('/') + 1)
        }
    }
};
</script>

<style>
.c-side-nav {
  float:left;
  background-color: #fff;
  min-height: calc(100% - 1.74rem);
  padding-bottom: 5000px;
  width:180px;
  height:100%;
  background:#fff;
  margin:20px 0 -5000px 0;
}
.c-side-nav-list{
  padding:10px 0;
}
.c-side-nav li{
  text-align:center;
}
.c-side-nav-list h3{
  position:relative;
  line-height:44px;
  font-size:18px;
  color:#333;
}
.c-side-nav-list h3 img{
  width:16px;
  margin-right:8px;
  vertical-align:-2px;
}
.c-side-atems{
  padding-left:10px;
  line-height:34px;
  font-size:14px;
}
.c-side-atems.active{
  background:#F0F0F0;
}

</style>
